export default __webpack_public_path__ + "media/color/xbp-7c5f8ab2.svg";